<template>
  <div class="empty-output">
    <img
      :src="flowerSvgPath"
      :alt="t('imageFlowerAlt')"
      class="empty-output__image"
    />

    <p class="message">{{ t('message') }}</p>
  </div>
</template>

<script setup lang="ts">
  import { useI18n } from '@experience/i18n';
  import ru from '../../i18n/ru.json';
  import { ref } from 'vue';

  const flowerSvgPath = ref(new URL('./flower.svg', import.meta.url).href);

  const { t } = useI18n({
    inheritLocale: true,
    messages: {
      ru,
    },
  });
</script>

<style src="./message.scss" scoped lang="scss" />
